// @flow

import {INPUT_TYPE} from '../../../../entities';

export const DEFAULT_CHECKOUT_INPUTS = [
  'Fecha de entrega',
  'Documento de identidad',
  'Comentario',
  'Información adicional',
];

export const DISABLED_DEFAULT_CHECKOUT_INPUTS = ['Documento de identidad'];

export const ALLOWED_CHECKOUT_INPUTS = [
  {
    name: 'Texto',
    inputType: INPUT_TYPE.TEXT,
  },
  {
    name: 'Número',
    inputType: INPUT_TYPE.NUMBER,
  },
  {
    name: 'Calendario',
    inputType: INPUT_TYPE.DATE_PICKER,
  },
  {
    name: 'Multi Opción',
    inputType: INPUT_TYPE.CHECKLIST,
  },
];

export const DAYS = [
  {
    name: 'Lunes',
    value: 'MONDAY',
  },
  {
    name: 'Martes',
    value: 'TUESDAY',
  },
  {
    name: 'Miercoles',
    value: 'WEDNESDAY',
  },
  {
    name: 'Jueves',
    value: 'THURSDAY',
  },
  {
    name: 'Viernes',
    value: 'FRIDAY',
  },
  {
    name: 'Sabado',
    value: 'SATURDAY',
  },
  {
    name: 'Domingo',
    value: 'SUNDAY',
  },
];
